import { CollisionGroup, CollisionGroupManager } from "excalibur";

export const collision_groups = {
    playerGroup: CollisionGroupManager.create('player'),
    enemyGroup: CollisionGroupManager.create('enemy'),
    bulletGroup: CollisionGroupManager.create('bullet'),
    towerGroup: CollisionGroupManager.create('tower'),
    towerRangeGroup: CollisionGroupManager.create('towerRange'),
    uiGroup: CollisionGroupManager.create('ui'),
    pathGroup: CollisionGroupManager.create('path')
}